"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _ChartStyles = require("../ChartStyles");

var _Display = _interopRequireDefault(require("./Display"));

var _Interaction = _interopRequireDefault(require("./Interaction"));

var _breakpoints = require("../../constants/breakpoints");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrap = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media only screen and (max-width: ", ") {\n    display: none;\n  }\n"])), _breakpoints.MAX_DESKTOP_BREAKPOINT);

var Minimap = /*#__PURE__*/function (_PureComponent) {
  _inherits(Minimap, _PureComponent);

  var _super = _createSuper(Minimap);

  function Minimap() {
    _classCallCheck(this, Minimap);

    return _super.apply(this, arguments);
  }

  _createClass(Minimap, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          delta = _this$props.delta,
          fieldServiceActivity = _this$props.fieldServiceActivity,
          isResizable = _this$props.isResizable,
          maxDateISO = _this$props.maxDateISO,
          meterReadings = _this$props.meterReadings,
          minDateISO = _this$props.minDateISO,
          onClickDate = _this$props.onClickDate,
          onDragEnd = _this$props.onDragEnd,
          onResizeEnd = _this$props.onResizeEnd,
          timeZone = _this$props.timeZone,
          unit = _this$props.unit,
          viewEndDateISO = _this$props.viewEndDateISO,
          viewStartDateISO = _this$props.viewStartDateISO;

      var minDate = _luxon.DateTime.fromISO(minDateISO, {
        zone: timeZone
      });

      var maxDate = _luxon.DateTime.fromISO(maxDateISO, {
        zone: timeZone
      });

      var viewStartDate = _luxon.DateTime.fromISO(viewStartDateISO, {
        zone: timeZone
      });

      var viewEndDate = _luxon.DateTime.fromISO(viewEndDateISO, {
        zone: timeZone
      });

      return /*#__PURE__*/_react["default"].createElement(Wrap, null, /*#__PURE__*/_react["default"].createElement(_ChartStyles.ChartContainer, {
        "data-tour": "minimap"
      }, /*#__PURE__*/_react["default"].createElement(_Display["default"], {
        delta: delta,
        maxDate: maxDate,
        meterReadings: meterReadings,
        fieldServiceActivity: fieldServiceActivity,
        minDate: minDate,
        timeZone: timeZone,
        unit: unit
      }), /*#__PURE__*/_react["default"].createElement(_ChartStyles.FillAvailableSpace, null, /*#__PURE__*/_react["default"].createElement(_Interaction["default"], {
        isResizable: isResizable,
        maxDate: maxDate,
        minDate: minDate,
        onClickDate: onClickDate,
        onDragEnd: onDragEnd,
        onResizeEnd: onResizeEnd,
        timeZone: timeZone,
        viewEndDate: viewEndDate,
        viewStartDate: viewStartDate
      }))));
    }
  }]);

  return Minimap;
}(_react.PureComponent);

Minimap.propTypes = {
  delta: _propTypes["default"].number,
  isResizable: _propTypes["default"].bool,
  fieldServiceActivity: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    actionCodeName: _propTypes["default"].string,
    actionId: _propTypes["default"].string,
    actionName: _propTypes["default"].string,
    caseId: _propTypes["default"].string,
    caseNumber: _propTypes["default"].string,
    closedDate: _propTypes["default"].string,
    componentCode: _propTypes["default"].string,
    componentCodeName: _propTypes["default"].string,
    createdDate: _propTypes["default"].string,
    dispatchFindings: _propTypes["default"].string,
    dispatchId: _propTypes["default"].string,
    dispatchName: _propTypes["default"].string,
    dispatchTime: _propTypes["default"].string,
    origin: _propTypes["default"].string,
    reason: _propTypes["default"].string,
    serviceContractName: _propTypes["default"].string,
    status: _propTypes["default"].string,
    subsetReason: _propTypes["default"].string
  })),
  maxDateISO: _propTypes["default"].string.isRequired,
  meterReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    solar: _propTypes["default"].number,
    timestamp: _propTypes["default"].string
  })),
  minDateISO: _propTypes["default"].string.isRequired,
  onClickDate: _propTypes["default"].func,
  onDragEnd: _propTypes["default"].func,
  onResizeEnd: _propTypes["default"].func,
  timeZone: _propTypes["default"].string,
  unit: _propTypes["default"].string,
  viewEndDateISO: _propTypes["default"].string.isRequired,
  viewStartDateISO: _propTypes["default"].string.isRequired
};
Minimap.defaultProps = {
  delta: 1,
  fieldServiceActivity: [],
  isResizable: false,
  meterReadings: [],
  onClickDate: undefined,
  onDragEnd: undefined,
  onResizeEnd: undefined,
  timeZone: '',
  unit: 'day'
};
var _default = Minimap;
exports["default"] = _default;